import React, { ReactNode } from "react";
import {
  ContainerActions,
  ContainerHeader,
  ContainerIcon,
  ContainerTitle,
  // Divider,
  TitleTypography,
} from "./style";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";

interface IHeaderPageProps {
  title: string;
  iconPage?: ReactNode;
  controlElement?: ReactNode[];
  goinBack?: () => void;
  className?: string;
}

export const PageHeader: React.FC<IHeaderPageProps> = ({
  title,
  iconPage,
  controlElement,
  className,
  goinBack,
}) => {
  return (
    <ContainerHeader className={className}>
      <>
        <ContainerTitle>
          {Boolean(goinBack) && (
            <IconButton onClick={goinBack} sx={{ padding: "0" }}>
              <ArrowBackIosNewOutlined
                sx={{ color: "white", fontSize: "16px", padding: "0" }}
              />
            </IconButton>
          )}
          {Boolean(iconPage) && <ContainerIcon>{iconPage}</ContainerIcon>}

          <TitleTypography>{title}</TitleTypography>
        </ContainerTitle>

        {/* <Divider /> */}
        <ContainerActions>
          {controlElement?.map((element) => element)}
        </ContainerActions>
      </>
    </ContainerHeader>
  );
};
